var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_17578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2854 0.5H5.71401V2.02381H10.2854V0.5ZM13.3559 5.36857L14.4378 4.28667C14.1102 3.8981 13.7521 3.53238 13.3635 3.21238L12.2816 4.29429C11.1007 3.34952 9.61496 2.78571 7.99972 2.78571C4.21305 2.78571 1.14258 5.85619 1.14258 9.64286C1.14258 13.4295 4.20544 16.5 7.99972 16.5C11.794 16.5 14.8569 13.4295 14.8569 9.64286C14.8569 8.02762 14.2931 6.5419 13.3559 5.36857ZM7.99972 14.9762C5.05115 14.9762 2.66639 12.5914 2.66639 9.64286C2.66639 6.69429 5.05115 4.30952 7.99972 4.30952C10.9483 4.30952 13.3331 6.69429 13.3331 9.64286C13.3331 12.5914 10.9483 14.9762 7.99972 14.9762ZM7.75591 11.1667H3.69496C4.12924 12.401 5.08163 13.3914 6.29305 13.879L6.20924 13.8333L7.75591 11.1667ZM12.3045 8.11905C11.8702 6.9 10.9483 5.91714 9.75972 5.42191L8.19782 8.11905H12.3045ZM6.94067 14.0848C7.28353 14.1686 7.63401 14.2143 7.99972 14.2143C9.02067 14.2143 9.95782 13.8714 10.7197 13.3076L9.1121 10.3362L6.94067 14.0848ZM4.60924 6.58762C3.87782 7.39524 3.42829 8.46952 3.42829 9.64286C3.42829 9.90191 3.45877 10.1533 3.49686 10.4048H7.09305L4.60924 6.58762ZM11.3064 12.7895C12.0911 11.9743 12.5711 10.8619 12.5711 9.64286C12.5711 9.38381 12.5407 9.13238 12.5026 8.88095H9.19591L11.3064 12.7895ZM9.01305 5.18571C8.68543 5.11714 8.3502 5.07143 7.99972 5.07143C6.93305 5.07143 5.9502 5.44476 5.17305 6.05429L6.94067 8.76667L9.01305 5.18571Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_17578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor_Icon.5f2ed90a844751f9d6c677a24a626bcd.svg";
export { ForwardRef as ReactComponent };